/** Existing support channel retained for blocked or unavailable Messenger. */
const SUPPORT_WHATSAPP_NUMBER = '56969075928';

/** @param message - Draft text, never sent automatically. @returns The existing support WhatsApp link. */
export function buildSupportWhatsAppUrl(message: string): string {
  return `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}
